import { camelize, underscore } from 'inflected';
import { metaKey } from '~/scripts/utils';

export default async ({ $api, app, $cookies, redirect, route, store }) => {
  const coverType = store.getters['products/getCoverType'];
  const notFound = () => {
    redirect(302,
             app.localePath(`/${coverType.basePath}/`),
             { flashClass: 'error', flashMessage: store.$i18n.t(`errors.${camelize(underscore(coverType.product))}SearchNotPresent`) });
  };
  const orderId = $cookies.get(`bonkers-ie-${coverType.product}-application`);
  const orderRequired = metaKey(route, 'orderRequired');
  if (!orderId) {
    if (orderRequired) {
      return notFound();
    }
    store.commit('order/reset', { type: 'lifeInsuranceApplication' });
    return;
  }
  await $api(`protection/life_insurance_applications/${orderId}`).then(r => {
    const plan = r.search.plans.find(p => p.code === r.plan_code);
    if (!plan) {
      return notFound();
    }
    store.commit('user/setCustomer', r.customer);
    store.commit('user/setJointCustomer', r.joint_customer);
    store.commit('products/set', plan);
    delete r.search.plans;
    store.commit('search/reset', { type: 'lifeInsurance', search: r.search });
    r.quote_premium = plan.quote_premium = r.search.best_advice_premiums[plan.code];

    if (r.customer) {
      route.meta[0] = { ...route.meta[0], jumbotronParams: { name: r.customer.fname } };
    }
    delete r.search;
    delete r.customer;
    delete r.joint_customer;
    store.commit('order/reset', { type: 'lifeInsuranceApplication', order: r });
    store.commit('order/set', { save_details: true });
  });
};
